console.log("Init.js...");
import { boot } from "quasar/wrappers";
import { useSettingsStore } from "src/stores/settings";

export default boot(async ({ app }) => {
  const settingsStore = useSettingsStore();
  await Promise.all([
    settingsStore.loadPrices(),
    settingsStore.loadProducts(),
  ]);
});
